/* global process */
let base = window._env_.VUE_APP_ORDER_AUDIT_API_HOST

export const queryCrontabJobsApi = params => {
  return axios.post(`${base}/admin/crontab_jobs/query`, params)
}
export const batchExportAuditInternApi = params => {
  return axios.post(`${base}/admin/crontab_jobs/export_intern_user`, params)
}
export const batchCreateInternApi = params => {
  return axios.post(`${base}/admin/crontab_jobs/add_intern_user`, params)
}
export const batchEditInternApi = params => {
  return axios.post(`${base}/admin/crontab_jobs/edit_intern_user`, params)
}
export const batchAddProjectAttendTargetApi = params => {
  return axios.post(`${base}/admin/crontab_jobs/add_project_attend_target`, params)
}
export const batchEditProjectAttendTargetApi = params => {
  return axios.post(`${base}/admin/crontab_jobs/edit_project_attend_target`, params)
}



// WEBPACK FOOTER //
// ./src/views/audit-batchjob/audit-batchjob.api.js